var React = require('react');

function IconPause (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",null,[React.createElement("g",{"transform":"translate(27.000000, 20.000000)","fill":"#FFFFFF","key":0},[React.createElement("rect",{"x":"0","y":"0","width":"5","height":"30","key":0}),React.createElement("rect",{"x":"11","y":"0","width":"5","height":"30","key":1})]),React.createElement("circle",{"stroke":"#FFFFFF","strokeWidth":"3","cx":"35","cy":"35","r":"33.5","key":1})])));
}

IconPause.defaultProps = {"width":"70px","height":"70px","viewBox":"0 0 70 70","version":"1.1"};

module.exports = IconPause;

IconPause.default = IconPause;
